import { ElementRef, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, UrlTree } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SecurityLayerService } from '../__auth/security-layer.service';
import { AuthService } from '../__auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];
  private currentRoute;
  public isLoggedIn = false;

  footerMenuItems = [
    {
      label: 'Inicio',
      id: 'home',
      class: 'nav-item ',
      icon: 'fas fa-home nav-icon',
      active: true,
      page: 'home'
    },
    {
      label: 'Apps',
      id: 'apps',
      class: 'nav-item ',
      icon: 'fas fa-grip-vertical nav-icon',
      active: false,
      page: 'apps'
    },
    {
      label: 'Procesos',
      id: 'my-project',
      class: 'nav-item ',
      icon: 'fas fa-file-alt nav-icon',
      active: false,
      page: 'my-project'
    }
  ];

  burgerMenuItems = [
    {
      label: 'FAQ',
      path: 'faqs',
      htmlId: '#faqs',
      enabled: true,
      icon: 'person',
      action: () => this.navigateTo('faqs')
    },
    {
      label: 'Blog',
      path: 'blog',
      htmlId: '#blog',
      enabled: false,
      icon: 'view_list'
    },
    {
      label: 'Términos y condiciones',
      path: 'terms',
      htmlId: '',
      enabled: false,
      icon: 'gavel'
    },
    {
      label: 'Contacto',
      path: 'contact',
      htmlId: '#contactSection',
      enabled: false,
      icon: 'contact_support'
    }
  ]

  userMenuItems = [
    {
      label: 'Configuración',
      path: 'settings',
      htmlId: '#contactSection',
      enabled: true,
      icon: 'settings',
      action: () => this.navigateTo('settings')
    },
    {
      label: 'Cerrar Sesión',
      path: 'logout',
      htmlId: '#logout',
      enabled: true,
      icon: 'power_settings_new',
      action: () => this.logout()
    }
  ];

  constructor(private router: Router,private securityLayer: SecurityLayerService,private authService: AuthService,private route: ActivatedRoute) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
      });

      this.isLoggedIn = this.authService.isUserLoggedIn;
      // Subscribe to login state changes
      this.authService.isUserLoggedIn$().subscribe((status) => {
        this.isLoggedIn = status;
        //this.updateNavigation();
      });
  }

  getPreviousUrl(): string | null {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    }
    return null;
  }

  navigateBack(): void {
    const previousUrl = this.getPreviousUrl();
    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigateByUrl('/home'); // Default route if no history exists
    }
  }

  navigateTo(route: string) {
    this.router.navigate([`/${route}`]);
  }

  goToViewSection(destination,targetSection){
    this.router.navigate([destination], { fragment: targetSection });
  }

  getCurrentRoute() {
    return this.currentRoute;
  }

  goBack(): void {
    this.navigateBack();
  }

  isPageActive(page){
    return this.getCurrentRoute() == '/'+page || this.getCurrentRoute() == '/';
  }

  isHeaderButtonVisible(buttonId){
    const route = '/'+this.getCurrentRouteWithoutFragment();
    switch(buttonId){
      case 'burger':
        if(this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/faqs"  || route === "/settings" ;
        }else{
          return false;
        }
      case 'userMenu':
        if(this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs" || route === "/settings"  || this.router.url.startsWith('/sub-app/');
        }else{
          return false;
        }
      case 'register':
        if(!this.isLoggedIn){
          return  route === "/login";
        }else{
          return false;
        }
      case 'login':
        /* if(!this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/" || route === "/my-project" || route === "/register" || route === "/faqs" || route === "/settings" || route === "/recover-password"  || this.router.url.startsWith('/sub-app/') || this.router.url.startsWith('/register/');
        }else{
          return false;
        } */
       return false;
      case 'videocall':
        if(!this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/" || route === "/my-project" || this.router.url.startsWith('/sub-app/');
        }else{
          return false;
        }
      case 'home':
        if(!this.isLoggedIn){
          return  route === "/login" || route === "/recover-password" || route === "/register" || this.router.url.startsWith('/register/') ;
        }else{
          return false;
        }
      case 'dots':
        if(this.isLoggedIn){
          return  route === "/settings";
        }else{
          return false;
        }
      case 'back':
        return this.router.url.startsWith('/sub-app/') || this.router.url.startsWith('/download/') || this.router.url.startsWith('/download-pdf/') || this.router.url.startsWith('/pdf-view/') || this.router.url.startsWith('/pdf-guide-view/');
      default:
        return false;
    }
  }

  showSpacer(){
    if(
      (!this.isHeaderButtonVisible('login') && !this.isHeaderButtonVisible('burger') && !this.isHeaderButtonVisible('back') && !this.isHeaderButtonVisible('videocall') && !this.isHeaderButtonVisible('home')) 
      || (!this.isHeaderButtonVisible('register') && !this.isHeaderButtonVisible('burger') && !this.isHeaderButtonVisible('back') && !this.isHeaderButtonVisible('videocall') && !this.isHeaderButtonVisible('home'))
      || (!this.isHeaderButtonVisible('register') && !this.isHeaderButtonVisible('burger') && !this.isHeaderButtonVisible('back') && !this.isHeaderButtonVisible('videocall') && !this.isHeaderButtonVisible('home') && !this.router.url.startsWith('/maintenance'))
    ){
      return true;
    }else{
      return false;
    }
  }

  logout(){
    this.securityLayer.logout();
  }

  isFooterButtonVisible(buttonId){
    const route = '/'+this.getCurrentRouteWithoutFragment();
    switch(buttonId){
      case 'home':
        return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs" || route === "/settings" || route === "/" || this.router.url.startsWith('/sub-app/');
      case 'apps':
          return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs" || route === "/settings" || route === "/" || this.router.url.startsWith('/sub-app/');
      case 'my-project':
        return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs" || route === "/settings" || route === "/" || this.router.url.startsWith('/sub-app/');
      default:
        return false;
    }
  }

  getCurrentRouteWithoutFragment(): string {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    const primary = tree.root.children['primary'];
    return primary
      ? primary.segments.map(s => s.path).join('/')
      : '';
  }

  isBurgerButtonVisible(buttonId){
    /* const route = this.getCurrentRoute(); */
    const route = this.getCurrentRouteWithoutFragment();
    switch(buttonId){
      case 'faqs':
        return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/settings" || this.router.url.startsWith('/sub-app/');
      case 'blog':
          return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/settings" || route === "/faqs" ;
      case 'terms':
        return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/settings"  || route === "/faqs" ;
      case 'contact':
        return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/settings" || route === "/faqs" ;
      case 'logout':
        if(this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs"  || this.router.url.startsWith('/sub-app/');
        }else{
          return false;
        }
      default:
        return false;
    }
  }

  isUserMenuButtonVisible(buttonId){
    const route = this.getCurrentRoute();
    switch(buttonId){
      case 'settings':
        return  route === "/apps" || route === "/home" || route === "/my-project" || this.router.url.startsWith('/sub-app/');
      case 'logout':
        if(this.isLoggedIn){
          return  route === "/apps" || route === "/home" || route === "/my-project" || route === "/faqs" || route === "/settings"  || this.router.url.startsWith('/sub-app/');
        }else{
          return false;
        }
      default:
        return false;
    }
  }

  getFooterButtonMenuItems(){
    let displayed = [];
    for(let menuButton of this.footerMenuItems){
      if(this.isFooterButtonVisible(menuButton.id)){
        displayed.push(menuButton);
      }
    }
    return displayed;
  }

  getBurgerMenuItems(){
    let displayed = [];
    for(let menuButton of this.burgerMenuItems){
      if(this.isBurgerButtonVisible(menuButton.path)){
        displayed.push(menuButton);
      }
    }
    return displayed;
  }

  getUserMenuItems(){
    let displayed = [];
    for(let menuButton of this.userMenuItems){
      if(this.isUserMenuButtonVisible(menuButton.path)){
        displayed.push(menuButton);
      }
    }
    return displayed;
  }

  /**
   * Scroll to the element matching the URL fragment.
   * @param route ActivatedRoute instance to read the fragment.
   * @param sectionMap A map of fragment keys to ElementRefs.
   */
  scrollToFragment(route: ActivatedRoute, sectionMap: { [key: string]: ElementRef<HTMLDivElement> }) {
    route.fragment.subscribe(fragment => {
      if (fragment && sectionMap[fragment]) {
        const targetElement = sectionMap[fragment].nativeElement;
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (fragment) {
        console.warn(`No matching element found for fragment: ${fragment}`);
      }
    });
  }

}